var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "svg",
    {
      attrs: {
        width: "14",
        height: "14",
        viewBox: "0 0 14 14",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
      },
    },
    [
      _c(
        "g",
        { attrs: { id: "location map", "clip-path": "url(#clip0_875_25676)" } },
        [
          _c("path", {
            attrs: {
              id: "Vector",
              d: "M7.6317 13.277C9.00082 11.5636 12.1234 7.41086 12.1234 5.07828C12.1234 2.24931 9.82816 -0.0458984 6.99918 -0.0458984C4.17021 -0.0458984 1.875 2.24931 1.875 5.07828C1.875 7.41086 4.99755 11.5636 6.36667 13.277C6.69493 13.6853 7.30343 13.6853 7.6317 13.277ZM6.99918 3.37022C7.45219 3.37022 7.88664 3.55018 8.20696 3.8705C8.52729 4.19083 8.70724 4.62528 8.70724 5.07828C8.70724 5.53129 8.52729 5.96574 8.20696 6.28607C7.88664 6.60639 7.45219 6.78635 6.99918 6.78635C6.54618 6.78635 6.11173 6.60639 5.7914 6.28607C5.47108 5.96574 5.29112 5.53129 5.29112 5.07828C5.29112 4.62528 5.47108 4.19083 5.7914 3.8705C6.11173 3.55018 6.54618 3.37022 6.99918 3.37022Z",
              fill: "#717986",
            },
          }),
        ]
      ),
      _c("defs", [
        _c("clipPath", { attrs: { id: "clip0_875_25676" } }, [
          _c("rect", { attrs: { width: "14", height: "14", fill: "white" } }),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }